<div class="dashboard-main container-fluid" *ngIf="loader" style="height: 550px;">
    <div class="loaderwrapper" style="z-index: 1024;">
        <span class="loader"></span>
    </div>
</div>
<section class="dashboard-main container-fluid" *ngIf="permissionsReady && permissions.canView && !loader">
    <div class="contents-main">
        <div class="col-12">
            <div class="card table-card">
                <!-- Title, filters and the page actions share one row at the top
                     of the card rather than stacking above it. -->
                <div class="table-toolbar">
                    <h1 class="table-toolbar__title">Daily Report</h1>
                    <div class="sb-filter-holder sb-filter-holder--inline">
                        <div class="input-wrapper">
                            <ng-select (change)="selectPlants($event)" placeholder="Plants" [items]="allPlantList"
                                bindLabel="stationName" bindValue="stationCode" class="sb-filter-field sb-filter-field--md">
                                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                    <ng-container *ngFor="let item of items; let i = index">
                                        <div class="ng-value" *ngIf="i < 1">
                                            <span class="ng-value-label">{{ item.stationName }}</span>
                                            <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                                        </div>
                                    </ng-container>
                                    <div class="ng-value" *ngIf="items.length > 1">
                                        <span class="ng-value-label">...</span>
                                    </div>
                                </ng-template>
                            </ng-select>
                        </div>
                        <div class="input-wrapper daterange-wrapper">
                            <input type="text" class="sb-filter-field sb-filter-field--md" bsDatepicker
                                [(ngModel)]="selectedDate" [bsConfig]="datePickerConfig" #dp="bsDatepicker"
                                (ngModelChange)="onRangeChange($event)" placeholder="Date" />

                            <span class="sb-filter-date-icon" (click)="dp.toggle()">
                                <span><svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16"
                                        fill="none">
                                        <path
                                            d="M12.8046 1.60066H12.0042V0H10.4036V1.60066H4.00087V0H2.40021V1.60066H1.59987C1.39011 1.60066 1.18241 1.64213 0.988734 1.72268C0.795054 1.80324 0.619218 1.9213 0.471327 2.07006C0.323435 2.21882 0.206406 2.39535 0.126986 2.5895C0.0475649 2.78365 0.00731745 2.99157 0.00854826 3.20133L0.000549316 14.3993C0.000549316 14.8239 0.169189 15.231 0.469373 15.5312C0.769556 15.8314 1.17669 16 1.60121 16H12.7992C13.2237 16 13.6309 15.8314 13.9311 15.5312C14.2312 15.231 14.3999 14.8239 14.3999 14.3993V3.20133C14.3999 2.77773 14.232 2.37141 13.933 2.07138C13.6339 1.77135 13.2282 1.60208 12.8046 1.60066ZM12.8046 14.398H1.60655V5.59433H12.8046V14.398Z"
                                            fill="currentColor" />
                                    </svg></span>
                            </span>
                        </div>
                    </div>
                    <button class="btn btn-dark rounded"
                        (click)="openModal(subscribe)">Subscribe</button>
                    <button class="btn btn-dark rounded"
                        (click)="openDownloadPopup(content)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                            fill="none">
                            <path d="M10 1.5V14.5L14 10.1667" stroke="currentColor" stroke-width="1.5"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M10 14.5L5 10.5" stroke="currentColor" stroke-width="1.5"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M1 18.5H19" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        Download</button>
                </div>
                <div class="table-wrap" [class.is-loading]="isLoadingTableInner">
                    <div class="loaderwrapper" *ngIf="isLoadingTableInner">
                        <span class="loader"></span>
                    </div>
                    <div class="table-header">
                        <div class="header-wrap">
                            <h3>INVERTOR PRODUCTION SUMMARY (KWhs)</h3>
                            <ul class="key-value-list">
                                <li>
                                    <div class="box">Plant Capacity</div>
                                    <div class="box">
                                        {{ plantDetails?.plant?.installed_capacity ?? '-' }}
                                    </div>
                                </li>
                                <li>
                                    <div class="box">Date</div>
                                    <div class="box">{{ plantDetails?.date ? (plantDetails.date | date:'dd-MMM-yyyy') :
                                        '-'
                                        }}</div>
                                </li>
                                <li>
                                    <div class="box">Weather</div>
                                    <div class="box">{{plantDetails?.weather||'-'}}</div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="table-main pb-4">
                        <table class="table-data text-center">
                            <thead>
                                <tr>
                                    <th>ESN CODE</th>
                                    <th>Inverter Capacity</th>
                                    <th>UNITS PRODUCTION</th>
                                    <th>SPECIFIC ENERGY</th>
                                    <th>CLEANING SCHEDULE</th>
                                    <th>INVERTER AVERAGE DOWN TIME (Hrs)</th>
                                    <th>Inverter Name</th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngIf="!isLoadingTableInner">
                                    <ng-container *ngIf="plantDetails; else initialMessage">
                                        <ng-container
                                            *ngIf="plantDetails?.devices && plantDetails?.devices.length>0 else noRow">
                                            <tr *ngFor="let item of plantDetails?.devices; let i = index">
                                                <td>{{ item.esnCode }}</td>
                                                <td>{{ item.capacity }}</td>
                                                <!-- unit producition is energy -->
                                                <td>{{ item.energy }}</td>
                                                <!-- unit producition is energy -->
                                                <td>{{ item.specific_yield }}</td>
                                                <td>-</td>
                                                <td>-</td>
                                                <td>{{ item.devName }}</td>
                                            </tr>
                                        </ng-container>
                                    </ng-container>
                                </ng-container>
                            </tbody>
                        </table>
                        <!-- <div class="table-meta">
                        <div class="entries flex-column align-items-start gap-3">
                            <label class="show-entries-list p-0">
                                Show
                                <select [formControl]="pageSizeControl" class="form-control form-control-sm"
                                    (change)="changePageSize()">
                                    <option *ngFor="let limit of pageRecordOptions" [value]="limit.value">
                                        {{ limit.label }}
                                    </option>
                                </select>
                                Entries
                            </label>
                            <span>Total Records: {{this.total_items }}</span>
                        </div>
                        <nav class="table-pagination">
                            <ul>
                                <li>
                                    <div class="go-to-page d-flex align-items-center">
                                        <label>Go to Page:</label>
                                        <input type="number" class="form-control form-control-sm" [(ngModel)]="pageToGo"
                                            min="1" [max]="total_pages"
                                            (keydown.enter)="goToPage(pageToGo); pageToGo = null">
                                        <div class="input-group-append">
                                            <button class="btn btn-primary" type="button"
                                                (click)="goToPage(pageToGo); pageToGo = null"
                                                [disabled]="pageToGo < 1 || pageToGo > total_pages">Go</button>
                                        </div>
                                    </div>
                                </li>
                                <li><a class="init-bg" id="firstPage" (click)="goToPage(1)"
                                        [class.disabled]="current_page === 1">1</a></li>
                                <li><a class="no-bg" id="prevPage" (click)="navigatePage('prev')"><i
                                            class="fa fa-chevron-left"></i></a></li>
                                <li><a class="active">{{ current_page }}</a></li>
                                <li><a class="no-bg" id="nextPage" (click)="navigatePage('next')"
                                        [class.disabled]="current_page === total_pages"><i
                                            class="fa fa-chevron-right"></i></a></li>
                                <li><a class="init-bg" id="lastPage" (click)="goToPage(total_pages)"
                                        [class.disabled]="current_page === total_pages">{{this.total_pages}}</a></li>
                            </ul>
                        </nav>

                    </div> -->
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 mt-3">
            <div class="card table-card">
                <div class="table-wrap py-5 px-4">
                    <div class="table-main text-center">
                        <table class="table-data headless-table table-bordered">
                            <tbody>
                                <tr>
                                    <td class="text-start cell-muted success">Total Energy Production/Day</td>
                                    <td>{{ plantDetails?.plant?.total_energy ?? '-' }}</td>
                                    <td>kwhs</td>
                                </tr>
                                <tr>
                                    <td class="text-start cell-muted">Global Irradiation</td>
                                    <td>{{ plantDetails?.plant?.global_irradiation ?? '-' }}</td>
                                    <td>kwh/m2</td>
                                </tr>
                                <tr>
                                    <td class="text-start cell-muted">Average Specific Yield</td>
                                    <td>{{ plantDetails?.plant?.avg_specific_yield ?? '-' }}</td>
                                    <td>-</td>
                                </tr>
                                <tr>
                                    <td class="text-start cell-muted">Energy Forcast (theoratical)</td>
                                    <td>{{ plantDetails?.plant?.theory_power ?? '-' }}</td>
                                    <td>kwhs</td>
                                </tr>
                                <tr>
                                    <td class="text-start cell-muted">Plant Utilization Factor(%UF)</td>
                                    <td>
                                        {{ plantDetails?.plant?.utilization_factor != null
                                        ? plantDetails.plant.utilization_factor + '%'
                                        : '-' }}
                                    </td>

                                    <td>-</td>
                                </tr>
                                <tr>
                                    <td class="text-start cell-muted">Deviation from theoratical Forcast</td>
                                    <td>{{ plantDetails?.plant?.deviation ?? '-' }}</td>
                                    <td>kwhs</td>
                                </tr>
                                <tr>
                                    <td class="text-start cell-muted">Remarks</td>
                                    <td colspan="2">-</td>
                                </tr>
                                <tr *ngFor="let item of citiesList; let i = index">
                                    <td>{{ item.srNo }}</td>
                                    <td>{{ item.name }}</td>
                                    <td>{{ item.region_name }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- NO VIEW PERMISSION (FULL PAGE) -->
<section *ngIf="permissionsReady && !permissions.canView && !loader" class="dashboard-main container-fluid bg-white">
    <div class="contents-main">
        <div class="row">
            <div class="col-12">
                <div class="empty-state text-center d-flex flex-column align-items-center justify-content-center py-5">
                    <i class="fa fa-lock fa-3x mb-3 text-muted"></i>
                    <h5 class="mb-2">Access Restricted</h5>
                    <p class="text-muted">
                        You don’t have permission to view this report.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>

<ng-template #content let-c="close" let-d="dismiss">
    <form [formGroup]="dailyReportForm" (ngSubmit)="downloadReport()">
        <div class="modal-header">
            <h4 class="modal-title" id="modal-basic-title">
                Daily Report
            </h4>
            <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click'); resetForm()">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                    <rect y="0.696289" width="24" height="24" rx="12" fill="white" />
                    <path d="M6.99988 7.69653L12.0514 12.748L17.1029 7.69653" stroke="currentColor" stroke-width="1.6"
                        stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M6.99995 18.3679L12.0505 13.3164L17.1021 18.3679" stroke="currentColor" stroke-width="1.6"
                        stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </button>
        </div>

        <div class="modal-body">
            <div class="row">
                <div class="col-md-12 form-styles my-3">
                    <label for="downtime">Downtime</label>
                    <ng-select [items]="downtimeList" bindLabel="label" bindValue="value" formControlName="downtime"
                        id="downtime" placeholder="Select Downtime">
                    </ng-select>
                    <small class="text-danger"
                        *ngIf="!dailyReportForm.get('downtime').valid && dailyReportForm.get('downtime').touched">
                        Please select downtime
                    </small>
                </div>

                <div class="col-md-12 mb-3 form-styles">
                    <label for="typeahead-basic">Description</label>
                    <textarea name="remarks" id="remarks" formControlName="remarks" class="form-control new"
                        maxlength="255" rows="3"></textarea>
                </div>
            </div>
        </div>
        <div class="modal-footer no-bg">
            <button type="button" class="btn btn-outline-dark" aria-label="Close"
                (click)="d('Cross click'); resetForm()" [disabled]="isDownloading">
                Cancel
            </button>
            <button type="submit" class="btn btn-orange" [disabled]="dailyReportForm.invalid">
                <ng-container *ngIf="!isDownloading; else downloading">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"
                        class="me-2">
                        <path d="M10 1.5V14.5L14 10.1667" stroke="currentColor" stroke-width="1.5"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M10 14.5L5 10.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path d="M1 18.5H19" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg> Download
                </ng-container>
                <ng-template #downloading>
                    <span class="spinner-border spinner-border-sm me-2"></span> Downloading...
                </ng-template>
            </button>
        </div>
    </form>
</ng-template>
<ng-template #subscribe let-c="close" let-d="dismiss">
    <form [formGroup]="subscribeForm">
        <div class="modal-header">
            <h4 class="modal-title">Report Subscription</h4>
            <button type="button" class="btn-close" (click)="d('Cross click'); resetForm()" [disabled]="isDownloading">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                    <rect y="0.696289" width="24" height="24" rx="12" fill="white" />
                    <path d="M6.99988 7.69653L12.0514 12.748L17.1029 7.69653" stroke="currentColor" stroke-width="1.6"
                        stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M6.99995 18.3679L12.0505 13.3164L17.1021 18.3679" stroke="currentColor" stroke-width="1.6"
                        stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </button>
        </div>

        <div class="modal-body">
            <!-- Loader -->
            <div *ngIf="isLoadingSubscription" class="d-flex justify-content-center align-items-center py-5">
                <div class="spinner-border text-primary" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
            <!-- Unsubscribe Confirm -->
            <div *ngIf="!isLoadingSubscription && showUnsubscribeConfirm" class="text-center py-3">
                <p class="mb-3">You will no longer receive emails for this report.</p>
                <div class="d-flex justify-content-center gap-2">
                    <button class="btn btn-outline-dark" (click)="cancelUnsubscribe()">Cancel</button>
                    <button class="btn btn-orange" (click)="unsubscribe()">Confirm Unsubscribe</button>
                </div>
            </div>
            <div class="form-group type-2" *ngIf="!isLoadingSubscription && !showUnsubscribeConfirm">

                <div class="row">
                    <div class="col-md-6 mb-2">
                        <label>Report Name</label>
                        <input type="text" class="form-control" value="Daily Report" disabled>
                    </div>
                    <div class="col-md-6 mb-2">
                        <label>Frequency</label>
                        <input type="text" class="form-control" value="Daily" disabled>
                    </div>

                    <div class="col-md-12 form-styles my-2">
                        <label for="plant">Plant <span class="text-danger">*</span></label>
                        <!-- <ng-select [items]="ownedPlants" bindLabel="stationName" bindValue="id" formControlName="plant"
                            id="plant" placeholder="Select Plant" [closeOnSelect]="true"
                            (change)="onPlantSelect($event)">
                        </ng-select> -->
                        <ng-select [items]="availablePlants" bindLabel="stationName" bindValue="id"
                            formControlName="plant" id="plant" placeholder="Select Plant"
                            (change)="onPlantSelect($event)">
                        </ng-select>
                    </div>

                    <!-- Plant Configured -->
                    <div class="col-md-12 mt-2" *ngIf="subscribedPlants.length > 0">
                        <label>Plant Configured</label>
                        <div class="d-flex flex-wrap gap-2 mt-1 p-2 border rounded">
                            <div *ngFor="let plant of subscribedPlants"
                                class="d-flex align-items-center gap-1 px-2 py-1 rounded"
                                style="background:#f0f0f0; font-size:13px; font-weight:500; color:#333;">
                                {{ plant.stationName }}
                                <span (click)="removePlant(plant)"
                                    style="cursor:pointer; margin-left:6px; font-size:16px; line-height:1; color:#888;">
                                    &times;
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-footer no-bg" *ngIf="!isLoadingSubscription && !showUnsubscribeConfirm">
            <button type="button" class="btn btn-orange waves-effect waves-light"
                [disabled]="!existingSubscription || isLoadingSubscription || isDownloading"
                (click)="confirmUnsubscribe()">
                Unsubscribe
            </button>
            <button type="button" class="btn btn-outline-dark" [disabled]="isLoadingSubscription || isDownloading"
                (click)="d('Cross click'); resetForm()">
                Cancel
            </button>
            <button type="button" class="btn btn-orange"
                [disabled]="subscribedPlants.length === 0 || isLoadingSubscription || isDownloading"
                (click)="saveSubscription()">
                <ng-container *ngIf="!isDownloading; else saving">Save</ng-container>
                <ng-template #saving>
                    <span class="spinner-border spinner-border-sm me-2"></span> Saving...
                </ng-template>
            </button>
        </div>
    </form>
</ng-template>

<ng-template #modalDelete let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">
            DELETE
        </h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click');">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect width="24" height="24" rx="12" fill="white" />
                <path d="M7 7.00024L12.0515 12.0518L17.103 7.00024" stroke="currentColor" stroke-width="1.6"
                    stroke-linecap="round" stroke-linejoin="round" />
                <path d="M6.99995 17.6716L12.0505 12.6201L17.1021 17.6716" stroke="currentColor" stroke-width="1.6"
                    stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </button>
    </div>
    <div class="modal-body">
        <p class="text-center">Are you sure you want to delete this City?</p>
    </div>
    <div class="modal-footer no-bg">
        <button type="button" class="btn btn-outline-dark" aria-label="Close" (click)="d('Cross click')">
            Cancel
        </button>
        <button type="button" class="btn btn-orange" (click)="c('confirm')" type="submit">
            Delete
        </button>
    </div>
</ng-template>
<ng-template #LoadingRow>
    <tr>
        <td colspan="100%">
            <div class="d-flex justify-content-center">
                <div class="spinner-border text-primary" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </td>
    </tr>
</ng-template>
<ng-template #noRow>
    <tr>
        <td colspan="7">
            <div class="fw-semibold text-center text-muted">
                No data found
            </div>
        </td>
    </tr>
</ng-template>

<ng-template #initialMessage>
    <tr>
        <td colspan="7" class="fw-semibold text-center text-muted">
            Please apply plant and date filter to view the report.
        </td>
    </tr>
</ng-template>